'use client';

import { ProgressBar } from 'types/navigation';
import ComplianceRiveProgressBar from './ComplianceRiveProgressBar';

const RiveProgressBar: React.FC<ProgressBar> = (props) => {
  return <ComplianceRiveProgressBar {...props} />;
};

export default RiveProgressBar;
